export default __webpack_public_path__ + "static/media/butterfly-park.ba950d69.mp4";